var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3289_1119)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.94434,
    y: 0.5,
    width: 4.33333,
    height: 1.66667,
    rx: 0.5,
    stroke: "#D2001F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2736 2.55423L13.0514 4.10978C13.2176 4.44223 12.9759 4.83339 12.6042 4.83339H1.443C1.0939 4.83339 0.852257 4.4847 0.974836 4.15783L1.55817 2.60227C1.55819 2.6022 1.55822 2.60213 1.55825 2.60207C1.63148 2.40703 1.81798 2.27783 2.02633 2.27783H11.8264C12.0155 2.27783 12.1884 2.38451 12.2732 2.55346C12.2734 2.55371 12.2735 2.55397 12.2736 2.55423Z",
    stroke: "#D2001F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61325 15.3142C3.5401 15.09 3.47182 14.7641 3.4237 14.348C3.42362 14.3473 3.42353 14.3465 3.42344 14.3457L2.75678 8.56797C2.65092 7.65056 2.6754 6.64834 2.78425 5.88515C2.83914 5.5003 2.91196 5.20194 2.98739 5.01277C2.99818 4.9857 3.00816 4.96311 3.01707 4.94444L11.3211 4.94445C11.3268 4.9565 11.3329 4.96993 11.3393 4.98484C11.4094 5.14939 11.4803 5.41481 11.5366 5.7668C11.6479 6.46324 11.6868 7.39765 11.6085 8.30393C11.6085 8.30414 11.6084 8.30436 11.6084 8.30458L11.1084 14.0824C11.1084 14.0827 11.1084 14.083 11.1083 14.0834C11.0613 14.6259 10.9796 15.0514 10.8877 15.3276C10.8844 15.3375 10.8811 15.3471 10.8779 15.3564C10.7873 15.4455 10.6631 15.5 10.5271 15.5L4.00225 15.5C3.84621 15.5 3.70539 15.4281 3.61325 15.3142Z",
    stroke: "#D2001F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3289_1119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash-red.d992527c.svg";
export { ForwardRef as ReactComponent };